module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-21.3bb63938.png";